import type { SVGProps } from "react";
// generated from Menu.svg — do not edit manually
// prettier-ignore
export default function Menu(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 8 H 21 M 3 16 H 21" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
